import { authInitialize } from './auth/actions';

export function initStore(): void {
    authInitialize();
}
